<ham-modal
    [title]="
        view === 'form'
            ? ('aumico_outbound_api_create_modal_title' | i18next)
            : ('aumico_outbound_api_secret_modal_title' | i18next)
    "
    [hideFooter]="true"
    [size]="'sm'"
    (cancel)="onClose()"
>
    <div class="create-modal-body">
        <!-- ─────────── Step 1: name + scopes ─────────── -->
        <ng-container *ngIf="view === 'form'">
            <label class="field">
                <span class="field__label">{{ 'aumico_outbound_api_name_label' | i18next }}</span>
                <input
                    class="field__input"
                    type="text"
                    maxlength="100"
                    data-testid="outbound-create-name"
                    [placeholder]="'aumico_outbound_api_name_placeholder' | i18next"
                    [(ngModel)]="displayName"
                />
            </label>

            <div class="field">
                <span class="field__label">{{ 'aumico_outbound_api_scopes_label_long' | i18next }}</span>
                <label class="scope-option" *ngFor="let option of scopeOptions">
                    <input
                        type="checkbox"
                        [attr.data-testid]="'outbound-scope-' + option.scope"
                        [checked]="selectedScopes.has(option.scope)"
                        (change)="toggleScope(option.scope)"
                    />
                    <span class="scope-option__text">
                        <span class="scope-option__name">{{ option.scope }}</span>
                        <span class="scope-option__description">{{ option.labelKey | i18next }}</span>
                    </span>
                </label>
            </div>

            <div class="error" *ngIf="error$ | async as error">{{ 'aumico_outbound_api_error_generic' | i18next }}</div>

            <div class="footer">
                <ham-button variant="gray" (buttonClick)="onClose()">{{ 'aumico_button_cancel' | i18next }}</ham-button>
                <ham-button
                    variant="primary"
                    data-testid="outbound-create-submit"
                    [disabled]="!canSubmit || (mutating$ | async) === true"
                    (buttonClick)="onSubmit()"
                    >{{ 'aumico_outbound_api_create_submit' | i18next }}</ham-button
                >
            </div>
        </ng-container>

        <!-- ─────────── Step 2: one-time credential reveal ─────────── -->
        <ng-container *ngIf="view === 'secret' && created != null">
            <div class="secret-warning" data-testid="outbound-secret-warning">
                {{ 'aumico_outbound_api_secret_warning' | i18next }}
            </div>

            <div class="credential">
                <span class="credential__label">{{ 'aumico_outbound_api_client_id_label' | i18next }}</span>
                <div class="credential__row">
                    <code class="credential__value" data-testid="outbound-created-client-id">{{ created.clientId }}</code>
                    <ham-button variant="gray" size="xs" (buttonClick)="onCopy('clientId')">
                        {{ (copiedField === 'clientId' ? 'aumico_outbound_api_copied' : 'aumico_outbound_api_copy') | i18next }}
                    </ham-button>
                </div>
            </div>

            <div class="credential">
                <span class="credential__label">{{ 'aumico_outbound_api_client_secret_label' | i18next }}</span>
                <div class="credential__row">
                    <code class="credential__value" data-testid="outbound-created-secret">{{ created.clientSecret }}</code>
                    <ham-button variant="gray" size="xs" (buttonClick)="onCopy('clientSecret')">
                        {{ (copiedField === 'clientSecret' ? 'aumico_outbound_api_copied' : 'aumico_outbound_api_copy') | i18next }}
                    </ham-button>
                </div>
            </div>

            <div class="footer">
                <ham-button variant="primary" data-testid="outbound-secret-done" (buttonClick)="onClose()">
                    {{ 'aumico_outbound_api_done' | i18next }}
                </ham-button>
            </div>
        </ng-container>
    </div>
</ham-modal>
